import { createStyles } from 'antd-style'

export const useStyles = createStyles(() => {
  return {
    colorPicker: {
      maxHeight: 260,
      overflowY: 'auto'
    }
  }
})
